import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight, Heart, Compass, Users, Ship } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { IMAGES } from "../data/demo";
import { StatusPill } from "../components/Bits";

const ICONS = [Heart, Compass, Users, Ship];

export default function Experiences() {
  const { t } = useLang();
  const nav = useNavigate();
  return (
    <div data-testid="experiences-page">
      <section className="relative min-h-[46vh] flex items-end overflow-hidden">
        <img src={IMAGES.carLifestyle} alt="Dubai experiences" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/70 to-ink/40" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-5 lg:px-8 pb-12 w-full">
          <StatusPill status="coming" />
          <h1 className="font-display text-4xl sm:text-5xl text-white mt-3 max-w-2xl">{t("experiences.title")}</h1>
          <p className="text-white/70 mt-3 max-w-2xl">{t("experiences.sub")}</p>
          <button onClick={() => nav("/ask", { state: { prompt: t("experiences.cta") } })}
            className="mt-6 inline-flex items-center gap-1.5 px-6 py-3 rounded-full bg-gold text-ink font-semibold hover:brightness-110 transition-all duration-200">
            {t("experiences.cta")} <ArrowRight size={16} />
          </button>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-5 lg:px-8 mt-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {t("experiences.cards").map((c, i) => {
            const Icon = ICONS[i] || Heart;
            return (
              <button key={i} onClick={() => nav("/ask", { state: { prompt: c.h } })}
                className="text-left rounded-2xl bg-surface/60 border border-white/[0.06] p-6 hover:border-gold/30 hover:-translate-y-1 transition-all duration-300">
                <div className="w-10 h-10 rounded-lg bg-gold/10 text-gold flex items-center justify-center"><Icon size={18} /></div>
                <div className="font-display text-lg text-white mt-3">{c.h}</div>
                <div className="text-white/55 text-sm mt-1">{c.p}</div>
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}
